<script setup>
  import SidebarPanelIcon from '@/features/layout/components/SidebarPanelIcon.vue'
  import { useLayoutStore } from '@/features/layout/useLayoutStore.js'

  const props = defineProps(['to', 'icon', 'icon-class'])

  const layoutStore = useLayoutStore()
  function handleClickMenuItem() {
    layoutStore.closeSidebar()
  }
</script>

<template>
  <li>
    <RouterLink class="link" :to="props.to" @click="handleClickMenuItem">
      <span class="link-icon">
        <SidebarPanelIcon :icon="icon" :icon-class="iconClass" />
      </span>
      <slot />
    </RouterLink>
  </li>
</template>

<style lang="scss" scoped>
  li {
    list-style: none;
    padding: 0;
    margin: 0;
  }

  .link {
    display: flex;
    padding: 0 16px;
    align-items: center;
    gap: 10px;
    color: var(--fm-ui-hamburger-link-color);
    border-left: 6px solid transparent;
    height: 45px;
    white-space: nowrap;
    font-weight: 400;
    font-size: 12px;

    &.router-link-active {
      background: var(--fm-ui-hamburger-link-active-background-color);
    }

    &:hover {
      background: var(--fm-ui-hamburger-link-hover-background-color);
      color: var(--fm-ui-hamburger-link-hover-color);
    }

    &:focus {
      background: var(--fm-ui-hamburger-link-focus-background-color);
      color: var(--fm-ui-hamburger-link-focus-color);
    }

    &:focus-within {
      background: var(--fm-ui-hamburger-link-focus-background-color);
      color: var(--fm-ui-hamburger-link-focus-color);
    }
  }

  .link-icon {
    width: 20px;

    svg {
      width: 100%;
    }
  }
</style>
